export const VALID_DATE_OF_BIRTH_WORDING =
  'The date of birth you selected means the driver is not eligible for this product'
